import { useState } from 'react';
import { useStore } from 'hooks/useRootStore';
import { useAppPreloader } from 'hooks/useAppPreloader';
import { useMutation, useQuery } from 'react-query';
import { Box } from '@material-ui/core';
import { useStyles } from './styles';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import { handleCompanyUrl } from 'utils/organizationUtils';
import { useHistory } from 'react-router-dom';
import { Card, CardContent, Typography, Grid } from '@material-ui/core';
import GoogleSvg from '../../../assets/googlelogo.svg';
import GithubSvg from '../../../assets/GitHub-logo.png';
export const AppDepartmentTable: React.FC = () => {
  const classes = useStyles();
  const history = useHistory();
  const {
    departmentTableStore: { getAppDepartment },
    ldapStore: { updateApp },
    AppStore: { providerList },
    notificationStore: { openNotification },
  } = useStore();
  const [currentDepartment] = useState<any>(JSON.parse(localStorage.getItem('CurrentDepartment') as string));
  const providerListReq = useQuery('providerListReq', () => providerList(), {
    onError: () => openNotification('error', `We are unable to connect `),
  });

  const entityId = currentDepartment?.department_id || currentDepartment?.id;
  const backRoute = '/department/users?value=three';
  const updateAppReq = useMutation((data: { providers: string[] }) => updateApp('department', entityId, data), {
    mutationKey: 'updateAppReq',
    onSuccess: async () => {
      // await getGroups();
      openNotification('success', 'Saved!!');
      localStorage.setItem('activeTab', 'two');
      history.push(handleCompanyUrl(backRoute));
    },
    onError: (error: any) => openNotification('error', error?.message || `Can't update apps`),
  });
  const getAppDepartmentReq = useQuery('getAppDepartment', () => getAppDepartment(currentDepartment?.department_id), {
    onError: (error: Error) => {
      openNotification('error', error.message);
    },
  });
  const allowedProviders = ['google', 'github'];
  const filteredProviders =
    providerListReq?.data?.filter(
      (app: any) =>
        app.tokenStatus !== 'expired' &&
        !getAppDepartmentReq?.data?.includes(app.provider) &&
        allowedProviders.includes(app.provider.toLowerCase())
    ) || [];
  const handleReSync = (provider: string) => {
    updateAppReq.mutate({
      providers: [provider],
    });
  };
  const getAppLogo = (appName: string) => {
    switch (appName.toLowerCase()) {
      case 'google':
        return GoogleSvg;
      case 'github':
        return GithubSvg;
      default:
        return GoogleSvg;
    }
  };

  const getCardClass = (appName: string) => {
    return `${classes.card} ${classes.approvedCard}`;
  };

  useAppPreloader(providerListReq.isFetching || updateAppReq.isLoading || getAppDepartmentReq.isLoading);
  return (
    <div>
      <div className={classes.page}>
        {!getAppDepartmentReq.isFetching &&
          (filteredProviders.length === 0 ? (
            <h1 className={classes.link}>No apps connected to this department.</h1>
          ) : (
            <Grid container spacing={3}>
              {filteredProviders.map((app: any) => (
                <Grid item xs={12} sm={6} md={4} key={app.id}>
                  <Card className={getCardClass(app.provider)}>
                    <CardContent>
                      <AddCircleOutlineIcon
                        className={classes.topIcon}
                        style={{
                          color: '#4CAF50',
                          fontSize: 28,
                          cursor: 'pointer',
                        }}
                        onClick={() => handleReSync(app.provider)}
                      />

                      <div className={classes.appRow}>
                        <img src={getAppLogo(app.provider)} alt={app.provider} className={classes.appIcon} />

                        <Box>
                          <Typography className={classes.appName}>{app.provider}</Typography>

                          <Typography className={classes.appDesc}>Access granted</Typography>
                        </Box>
                      </div>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          ))}
      </div>
    </div>
  );
};
